module.exports = __webpack_public_path__ + "img/mech.107ea465.jpg";